









































import Vue from "vue";
import { Component, Prop, Provide, Watch } from "vue-property-decorator";
import { TableData, TableDataField } from "../types";
import TableConfig from "../tableConfig.model";
import {BTable} from "bootstrap-vue/src/components/table";
import {BPagination} from "bootstrap-vue/src/components/pagination";
import { BCollapse } from 'bootstrap-vue/src/components/collapse';

@Component({
  //@ts-ignore
  components: {  BTable, BPagination,BCollapse }
})

export default class MapTable extends Vue {
  @Prop({default: new TableConfig()}) tableData!: TableData;
  //@Prop({default: []}) tableItems! : object[];
  striped: boolean = true;
  perPage: number = 10;
  totalRows:number = 0;
  currentPage: number = 1;
  size: string = "sm";
  small: boolean = true;
  responsive: string = "xl";
  firstpagetext: string = '<span class="text-hide">Previous Page</span>';
  lastpagetext: string = '<span class="text-hide">Next Page</span>';
  showCollapse: boolean = false;
  //items: object[] = [];
  fields: TableDataField[] = [];
  sortBy: string = "" ;
  
   
  mounted() {
    this.showCollapse = screen.width >= 768 ? true : false;
        
  }

  @Watch('tableData', {immediate: true}) onTableChange(){
     
    this.totalRows = this.tableData.items.length;
    //this.items = this.tableData.items;
    this.sortBy = this.tableData.sortBy;
  }
}
